import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBrandfolderComponent } from './simple-icons-brandfolder.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBrandfolderComponent ],
    exports:      [ SimpleIconsBrandfolderComponent ],
    bootstrap:    []
})
export class SimpleIconsBrandfolderModule {}
